import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useMutation, useQueryClient } from "react-query";
import { cancelLoanRequestBySupplier } from "../../services/loan.service";
import { REFERENCE_KEY } from "../../config/cacheKey";
import { useHistory } from "react-router-dom";
import { ReferenceKeyRequest } from "../../models/loan.model";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function ModalCancelLoan({ openModel }: any) {
  const [open, setOpen] = React.useState<boolean>(openModel);
  React.useEffect(() => {
    setOpen(openModel);
  }, [openModel]);

  const history = useHistory();
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const queryClient = useQueryClient();
  const referenceKey = new ReferenceKeyRequest();
  referenceKey.referenceKey = queryClient.getQueryData(REFERENCE_KEY);
  const cancelLoanRequestBySupplierMutation = useMutation(
    cancelLoanRequestBySupplier,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          //todo reg supp
          history.push("/loan/SupplierSettlementCartable");
          // history.push("/loan/loan-list");
        }
      },
    }
  );
  const handelVerify = () => {
    if (referenceKey.referenceKey) {
      cancelLoanRequestBySupplierMutation.mutate(referenceKey!);
    }
  };
  const handelCancel = () => {
    handleClose();
  };

  return (
    <div>
      <div onClick={handleOpen}>
        <span className=" colorRed cursorPointer">
          {" "}
          <span style={{ paddingRight: "20px", color: "#C1C7CB" }}> |</span>
          لغو درخواست و حذف پرونده
        </span>
        &nbsp;
        <HighlightOffIcon style={{ color: "red" }} />
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{ borderRadius: "6px", padding: "40px 70px 70px 60px" }}
          className="ModalCmp textCenter "
        >
          <div>
            <Typography className="textCenter mTop30 mbottom20">
              آیا از{" "}
              <b className="colorCancel">
                لغو درخواست تسهیلات و حذف این پرونده
              </b>{" "}
              اطمینان دارید؟
            </Typography>
          </div>
          <Grid container spacing={2} columns={16} className="mTop20">
            <Grid item xs={8}>
              <Button
                onClick={handelVerify}
                fullWidth
                className="btnForm SuccessDefault"
              >
                بله
              </Button>
            </Grid>
            <Grid item xs={8}>
              <Button
                onClick={handelCancel}
                fullWidth
                className="btnForm DangerDefault"
              >
                خیر
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
